import styled from "styled-components";

export const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0);
  display: flex;
  z-index: 1000;
`;

export const PopupContainer = styled.div`

  display: flex;
  padding: 1rem;
  border-radius: 2px;
  width: auto;
  min-width: 50px;
  position: fixed;
  background: var(--dark-blue);
  flex-direction: column;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  bottom: 5rem;
  right: 38%;
  
  
  h2 {
    color: white;
    margin-bottom: 1rem;
    font-size: 1.2rem;
    text-align: center;
  }


@media (max-width: 768px) {
  bottom: 5rem;
  right: 2%;
  
  h2 {
    color: white;
    margin-bottom: 1rem;
    font-size: 1.2rem;
    text-align: center;
  }

}
  
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  color: white;
  opacity: 0.8;
  height: 24px;
  width: 24px;
  
  &:hover {
    background-color: var(--hover);
  }
`;

export const OptionsContainer = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Option = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;

  label {
    font-size: 0.9rem;
    color: white;
  }

  div {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    button {
      background: white;
      border: none;
      border-radius: 2px;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--dark-blue);
      cursor: pointer;
      font-weight: bold;

      &:hover {
        background: #f0f0f0;
      }
    }

    span {
      color: white;
      min-width: 40px;
      text-align: center;
    }
  }
`;


export const AccessibilityButton = styled.button`
  font-size: 23px;
  font-weight: 500;
  line-height: 21.09px;
  color: #fff;
  background-color: transparent;
  width: 40px;
  height: 40px;
  border: 0;
  transition: filter 0.2s;

  &:hover {
    filter: brightness(0.9);
  }

  @media (max-width: 560px) {
    gap: 10px;
    justify-content: center;
    button {
      font-size: 14px;
      width: 30px;
      height: 30px;
    }
  }
`;
